module.exports = __webpack_public_path__ + "img/cart.cd3fd262.png";